import React, { useContext } from 'react';
import context from '../context';
import styled from 'styled-components';
import {
  FacebookOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  YoutubeOutlined,
  TwitterOutlined
} from '@ant-design/icons';

import Logo from './logo';

const Wrap = styled.footer`
  background: #f3f3f2;
  padding: 60px 0 40px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr 1fr;
  gap: 50px;
  align-items: start;
  width: 80%;
  margin: 0 auto;

  @media (max-width: 992px){
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }
  @media (max-width: 576px){
    grid-template-columns: 1fr;
    gap: 28px;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h4`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 14px;
  color: #111;
`;

const Link = styled.a`
  font-size: 0.95rem;
  color: #444;
  margin-bottom: 10px;
  text-decoration: none;
  transition: color .2s ease;

  &:hover {
    color: ${p => p.theme.primaryColor};
  }
`;

const SocialRow = styled.div`
  display: flex;
  gap: 22px;
  margin-top: 28px;

  a{
    color: #111;
    font-size: 26px;
    line-height: 1;
    transition: opacity .2s ease;
  }
  a:hover{ opacity: .85; }
`;

const Divider = styled.hr`
  border: 0;
  border-top: 1px solid rgba(0,0,0,.12);
  margin: 40px auto 24px;
  width: 80%;
`;

const BottomBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  margin: 0 auto;
  padding: 20px 0 30px;
  color: #2b2b2b;
  font-size: 15px;

  @media (max-width: 576px){
    flex-direction: column;
    gap: 14px;
    text-align: center;
  }
`;

export default function Footer(){
  const state = useContext(context);

  return (
    <Wrap>
      <Grid>
        {/* Columna 1: Logo + redes */}
        <Column>
          <Logo dark />
          <SocialRow>
            <a href={state.instagram} target="_blank" rel="noopener noreferrer"><InstagramOutlined /></a>
            <a href={state.facebook} target="_blank" rel="noopener noreferrer"><FacebookOutlined /></a>
            <a href={state.twitter} target="_blank" rel="noopener noreferrer"><TwitterOutlined /></a>
            <a href={state.linkedin} target="_blank" rel="noopener noreferrer"><LinkedinOutlined /></a>
            <a href={state.youtube} target="_blank" rel="noopener noreferrer"><YoutubeOutlined /></a>
          </SocialRow>
        </Column>

        {/* Columna 2 */}
        <Column>
          <Title>Las Flores Inmobiliaria</Title>
          <Link href="/in-construction">Construcción</Link>
          <Link href="/in-construction">Arquitectura</Link>
          <Link href="/in-construction">Tasación</Link>
          <Link href="/in-construction">Desarrollo de Proyectos</Link>

        </Column>

        {/* Columna 3 */}
        <Column>
          <Title>Contáctanos</Title>
          <Link href="/in-construction">Nosotros</Link>
          <Link href="/in-construction">Misión</Link>
          <Link href="/in-construction">Visión</Link>
        </Column>

        {/* Columna 4 */}
        <Column>
          <Title>Síguenos</Title>
          <Link href={state.facebook}>Facebook</Link>
          <Link href={state.instagram}>Instagram</Link>
          <Link href={state.linkedin}>Linkedin</Link>
        </Column>
      </Grid>

      <Divider />

      <BottomBar>
        <div>
          <Link href="/in-construction">Términos y Condiciones</Link> &nbsp; | &nbsp;
          <Link href="/in-construction">Política de Privacidad</Link>
        </div>
        <span>© {new Date().getFullYear()} Las Flores</span>
      </BottomBar>
    </Wrap>
  );
}